import axios, { AxiosResponse } from "axios";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from "../../models/OctResponse";
import { APP_CONFIGURATION_KEYS, ORDER_TYPE_ID } from "../../utils/Constant";
import { GopLanKhamBenhAnParams, ICombineTreatment, ICombineTreatmentDepartmentParams } from "../models/TiepDonModels";
import { PagingParams } from "../../utils/ParamsUtils";

export const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL] || process.env.REACT_APP_INPATIENT_API_URL;
const API_PATH_CIS = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;
const API_PATH_XADMIN = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL;
const API_HANH_CHINH = API_PATH + "/treatment";

export const getInpatientCategoryByCode = (code: string) => {
    let url = API_PATH + `/medical-record/category/${code}`;
    return axios.get(url);
}

export const getCategoryDepartment = (params: {level: number, parentCode: string}) => {
    let url = API_PATH + "/category/department";
    return axios.get(url, { params });
}

export const getChamberList = (params: any) => {
    let url = API_PATH + "/chambers/search";
    return axios.get(url, { params });
}

export const getBedList = (params: any) => {
    let url = API_PATH + "/beds/search";
    return axios.get(url, { params });
}

export const getListBedService = (params: {termIds: string}) => {
    let url = `${API_PATH}/terms/attribute-value`;
    return axios.get(url, {params});
}

export const getDepartmentList = (params: any ) => {
    let url = API_PATH_XADMIN + "/departments/search";
    return axios.get(url, {params});
}

export const getDsBenhNhan = (params: any) => {
    let url = API_HANH_CHINH;
    return axios.get(url, { params: {...params, treatmentDeleted: false} });
}

export const getDsTrangThai = (params: any) => {
    let url = API_HANH_CHINH + "/summary-statuses";
    return axios.get(url, { params });
}

export const getThongTinNhapVien = (treatmentId: string) => {
    let url = API_HANH_CHINH + `/assign/${treatmentId}`;
    return axios.get(url);
}

export const fetchNhapVien = (treatmentId: string, data: any) => {
    let url = API_HANH_CHINH + `/assign/${treatmentId}`;
    return axios.put(url, data);
}

export const fetchHuyNhapVien = (treatmentId: string) => {
	let url = API_HANH_CHINH + `/assign/${treatmentId}/cancel`;
	return axios.post(url);
}

export const getThongTinBenhNhan = (treatmentId: string) => {
    let url = API_HANH_CHINH + `/patient/${treatmentId}`;
    return axios.get(url);
}

export const getDsPhieuDichVu = (treatmentId: string, type: string, treatmentSheetId?: string) => {
    let url = API_PATH + `/order-groups/treatment-id/${treatmentId}/type/${type}`;
	return axios.get(url, { params: { treatmentSheetId } });
}

export const getDsPhieuThuocVatTu = (treatmentId: string, type: string, treatmentSheetId?: string) => {
    let url = API_PATH + `/medical-item-group/treatment-id/${treatmentId}/type/${type}`;
    return axios.get(url, { params: { treatmentSheetId } });
}

export const getDetailPhieuThuocVatTu = (groupId: string) => {
    let url = API_PATH_CIS + `/medical-item-order/group-id/${groupId}`;
    return axios.get(url);
}

export const getLichSuDieuTri = (patientId: string) => {
    let url = API_PATH + `/medical-treatment-history/patient/${patientId}`;
    return axios.get(url);
}

export const getDsKetQuaDieuTri = () => {
    let url = API_PATH + `/category/treatmentConclusion`;
    return axios.get(url);
}

export const getDsHinhThucXuTri = () => {
    let url = API_PATH + `/category/treatmentConclusionModality`;
    return axios.get(url);
}

export const fetchXuTriNoiTru = (data: any) => {
    let url = API_PATH + `/treatment-conclusion`;
    return axios.post(url, data);
}

export const getThongTinXuTriNoiTru = (treatmentId: string) => {
    let url = API_PATH + `/treatment-conclusion/${treatmentId}`;
    return axios.get(url);
}

export const saveCombinedOrder = async (params: any): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH}/service-prescription/combined-order`,
		params
	);
	return data;
};

export const cancelCombinedOrder = async (params: any): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH_CIS}/medical-exam/combined-order/cancel`,
        null,
		{
            params
        }
	);
	return data;
};

export const getCombineOrders = async (treatmentId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/service-prescription/treatment/id/${treatmentId}/type/${ORDER_TYPE_ID.KHAM_KET_HOP}`
	);
	return data;
};

export const getListCombineDepartment = async (
	params: ICombineTreatmentDepartmentParams
): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/combined-treatment/departments`,
		{ params }
	);
	return data;
};

export const combineTreatment = async (params: ICombineTreatment): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH}/combined-treatment`,
        params
	);
	return data;
};

export const getListCombineTreatment = async (params: any): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/combined-treatment/cancelable`,
        {
            params
        }
	);
	return data;
};

export const cancelCombineTreatment = async (treatmentId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH}/combined-treatment/id/${treatmentId}/cancel`,
	);
	return data;
};

export const cancelTreatmentConclusion = async (
	treatmentConclusionId: string,
	params?: any
): Promise<OctResponse<any>> => {
	const { data } = await axios.put<OctResponse<any>>(
		`${API_PATH}/treatment-conclusion/cancel/${treatmentConclusionId}`, params
	);
	return data;
};

export const inGiayChuyenTuyen = (params: { medicalRecordId: string; exportType: string }) => {
	return axios.post<Blob>(`${API_PATH}/download/referral-paper`, null, {
		params,
		responseType: 'blob',
	});
};

export const getDanhSachLanKham = async (params: { medicalRecordId: string }) => {
	const { medicalRecordId } = params;
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/medical-record/record/${medicalRecordId}/clinical-orders`
	);
	return data;
};

export const gopLanKhamBenhAn = async (params: GopLanKhamBenhAnParams) => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH}/medical-record/record/attach-orders`,
		params
	);
	return data;
};

export const getBedCategory = async (
	params: PagingParams & {
		deptDepartmentId?: string;
	}
) => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH}/beds/search`, {
		params,
	});
	return data;
};